/////////////////////////////////////////////////////////////////////////// CODICE GESTIONE COLORI /////////////////////////////////////////////////////////////////////////////////////////////


document.addEventListener("DOMContentLoaded", function () {
  function initializeColorVariantListeners() { 
  document.querySelectorAll(".collection-product-card__swatch-container").forEach(productCard => { // Per ogni prodotto
    const showMoreButton = productCard.querySelector(".show-more-swatches"); // Trova *il* bottone "+"

    if (showMoreButton) { // Se il bottone esiste (potrebbe non esserci se ha meno di 6 colori)
      let isExpanded = false; // Stato: inizialmente non espanso

      showMoreButton.addEventListener("click", function () {
      const container = this.closest(".collection-product-card__swatch-container");
      const hiddenSwatches = container.querySelectorAll(".hidden-swatch");
      const buttonImage = this.querySelector("img");
      
      if (!isExpanded) { // Se NON è espanso (mostra)
        hiddenSwatches.forEach(swatch => {
          swatch.style.opacity = '1';
          swatch.style.display = 'block'; // o 'inline-block' se preferisci
          swatch.classList.add("visible");
          container.appendChild(this.parentElement);
        });
        buttonImage.src = "https://cdn.shopify.com/s/files/1/0911/1198/1395/files/meno_1_1.png?v=1739752749";
        
        isExpanded = true;
      } else { // Se è espanso (nascondi)
        hiddenSwatches.forEach(swatch => {
          swatch.style.opacity = '0';
          swatch.style.display = 'none';
          swatch.classList.remove("visible");
        });
        buttonImage.src = "https://cdn.shopify.com/s/files/1/0911/1198/1395/files/cnjzgvbbm_1.png?v=1739750883";
        isExpanded = false;
      }
      });       
    }
  });
}

initializeColorVariantListeners();
 // Monitora le modifiche al contenitore dei prodotti
  const mainFilter = document.getElementById('main-collection-filters');
  if (mainFilter) {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length) {
          initializeColorVariantListeners(); // Riattiva gli event listener
        }
      });
    });

    observer.observe(mainFilter, { childList: true, subtree: true });
  }
  
});

